import React from 'react';
import { SearchAndShowController } from './definitions';

export const SearchAndShowControllerContext = React.createContext<SearchAndShowController>({} as SearchAndShowController);

//  This exposes the controller to every child that wants to use it :-)
export const useSearchAndShowProvider = () => React.useContext(SearchAndShowControllerContext);
